var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "before-close": _vm.handleClose,
        title: _vm.config.title,
        visible: _vm.dialogVisible,
        width: "480px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "mt15" }, [
        _vm.config.command !== 5
          ? _c(
              "div",
              { staticClass: "current-dialog mb15" },
              [
                _c("span", [_vm._v("文件类型：")]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择文件类型" },
                    model: {
                      value: _vm.info.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.info, "type", $$v)
                      },
                      expression: "info.type",
                    },
                  },
                  _vm._l(_vm.options, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "current-dialog mb15" },
          [
            _c("span", [_vm._v("文件名称：")]),
            _vm._v(" "),
            _c("el-input", {
              attrs: {
                placeholder:
                  _vm.config.command === 5 ? "填写文件夹名称" : "填写文件名称",
                maxlength: "20",
                type: "text",
              },
              model: {
                value: _vm.info.name,
                callback: function ($$v) {
                  _vm.$set(_vm.info, "name", $$v)
                },
                expression: "info.name",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading, size: "small", type: "primary" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }